import { Heading } from 'components/Heading';
import SalonContact from 'components/SalonContact/SalonContact';

import { useBusiness } from 'hooks/business/useBusiness';
import { usePreferences } from 'hooks/preferences/usePreferences';

import s from './ServicesError.module.css';

export const ServicesError = () => {
  const { promptForContactOnBooking } = usePreferences();
  const { email, phone, cellPhone } = useBusiness();

  return (
    <section className={s.root}>
      <Heading>This page is temporarily unavailable</Heading>
      <p>
        We&apos;re on it, making things flawless again.
        <br /> Please check back later or contact us directly{' '}
        {promptForContactOnBooking && (
          <SalonContact
            businessEmail={email}
            businessPhone={phone}
            cellPhone={cellPhone}
          />
        )}
      </p>
    </section>
  );
};
